import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, unref as _unref, vModelSelect as _vModelSelect, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "moves-page" };
const _hoisted_2 = { class: "moves-layout" };
const _hoisted_3 = { class: "moves-list-panel" };
const _hoisted_4 = { class: "filter-buttons" };
const _hoisted_5 = { class: "search-box" };
const _hoisted_6 = { class: "move-count" };
const _hoisted_7 = { class: "moves-list" };
const _hoisted_8 = {
    key: 0,
    class: "move-items"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "move-name" };
const _hoisted_11 = { class: "move-meta" };
const _hoisted_12 = { class: "move-priority" };
const _hoisted_13 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_14 = { class: "move-details-panel" };
const _hoisted_15 = { class: "top-actions" };
const _hoisted_16 = {
    key: 0,
    class: "details-content"
};
const _hoisted_17 = { class: "detail-header" };
const _hoisted_18 = { class: "form-row" };
const _hoisted_19 = { class: "form-group" };
const _hoisted_20 = { class: "form-group" };
const _hoisted_21 = { class: "flags-row" };
const _hoisted_22 = { class: "form-group priority-group" };
const _hoisted_23 = { class: "form-group checkbox" };
const _hoisted_24 = { class: "form-group checkbox" };
const _hoisted_25 = { class: "form-group checkbox" };
const _hoisted_26 = { class: "form-group checkbox" };
const _hoisted_27 = { class: "form-group checkbox" };
const _hoisted_28 = { class: "form-group" };
const _hoisted_29 = { class: "form-row" };
const _hoisted_30 = { class: "form-group" };
const _hoisted_31 = { class: "form-group" };
const _hoisted_32 = { class: "form-group" };
const _hoisted_33 = { class: "form-row three" };
const _hoisted_34 = { class: "form-group" };
const _hoisted_35 = { class: "form-group" };
const _hoisted_36 = { class: "form-group" };
const _hoisted_37 = { class: "form-group checkbox" };
const _hoisted_38 = { class: "form-group" };
const _hoisted_39 = { class: "form-group" };
const _hoisted_40 = { class: "input-with-button" };
const _hoisted_41 = ["src"];
const _hoisted_42 = { class: "form-group" };
const _hoisted_43 = { class: "input-with-button" };
const _hoisted_44 = ["src"];
const _hoisted_45 = { class: "form-group" };
const _hoisted_46 = { class: "input-with-button" };
const _hoisted_47 = ["src"];
const _hoisted_48 = { class: "move-action-section" };
const _hoisted_49 = { class: "type-buttons" };
const _hoisted_50 = { key: 0 };
const _hoisted_51 = { class: "form-row" };
const _hoisted_52 = { class: "form-group" };
const _hoisted_53 = ["value"];
const _hoisted_54 = { class: "form-group" };
const _hoisted_55 = { key: 0 };
const _hoisted_56 = { class: "form-group" };
const _hoisted_57 = { class: "form-group" };
const _hoisted_58 = { class: "final-action" };
const _hoisted_59 = { key: 1 };
const _hoisted_60 = { class: "form-group" };
const _hoisted_61 = { class: "final-action" };
const _hoisted_62 = { key: 2 };
const _hoisted_63 = { class: "form-group" };
const _hoisted_64 = { class: "final-action" };
const _hoisted_65 = { key: 3 };
const _hoisted_66 = { class: "form-group" };
const _hoisted_67 = { class: "final-action" };
const _hoisted_68 = { class: "form-group checkbox" };
const _hoisted_69 = { class: "form-group checkbox" };
const _hoisted_70 = { class: "form-group checkbox" };
const _hoisted_71 = { class: "form-group" };
const _hoisted_72 = { class: "form-group" };
const _hoisted_73 = { class: "form-group" };
const _hoisted_74 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_75 = { class: "drawer-header" };
const _hoisted_76 = { class: "drawer-content" };
const _hoisted_77 = {
    key: 0,
    class: "criteria-facts"
};
const _hoisted_78 = ["title", "onClick"];
const _hoisted_79 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_80 = { class: "modal-header" };
const _hoisted_81 = { class: "modal-body" };
const _hoisted_82 = { class: "search-box" };
const _hoisted_83 = ["placeholder"];
const _hoisted_84 = {
    key: 0,
    class: "file-grid"
};
const _hoisted_85 = ["onClick"];
const _hoisted_86 = { class: "file-preview" };
const _hoisted_87 = ["src"];
const _hoisted_88 = ["src", "alt"];
const _hoisted_89 = { class: "file-card-info" };
const _hoisted_90 = ["title"];
const _hoisted_91 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_92 = { class: "modal-header" };
const _hoisted_93 = { class: "modal-body" };
const _hoisted_94 = { class: "modal-footer" };
import { ref, computed, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import AppActionCard, { APP_SCREEN_OPTIONS } from '@/admin/components/AppActionCard.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MovesPage',
    setup(__props) {
        const admin = useAdmin();
        const moves = ref([]);
        const selectedMove = ref(null);
        const criteria = ref([]);
        const actionType = ref(null);
        const listFilter = ref('all');
        const searchQuery = ref('');
        const showCriteriaDrawer = ref(false);
        const showDeleteConfirm = ref(false);
        const showFilePicker = ref(false);
        const fileSearchQuery = ref('');
        const pickerMode = ref('image');
        const pickerField = ref(null);
        const cdnFiles = ref([]);
        const IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'];
        const VIDEO_EXTS = ['mp4', 'webm', 'mov', 'm4v', 'ogg'];
        const showSuccessToast = ref(false);
        const successMessage = ref('');
        const showErrorToast = ref(false);
        const errorMessage = ref('');
        const filteredMoves = computed(() => {
            let list = moves.value;
            if (listFilter.value === 'cms')
                list = list.filter((p) => p.cmsPage != null);
            if (listFilter.value === 'screen')
                list = list.filter((p) => p.appScreen != null);
            if (listFilter.value === 'website')
                list = list.filter((p) => p.websiteUrl != null);
            const query = searchQuery.value.trim().toLowerCase();
            if (!query)
                return list;
            return list.filter((p) => (p.name || '').toLowerCase().includes(query));
        });
        const filteredCdnFiles = computed(() => {
            const query = fileSearchQuery.value.toLowerCase();
            const exts = pickerMode.value === 'video' ? VIDEO_EXTS : IMAGE_EXTS;
            return cdnFiles.value.filter((f) => f.fileName.toLowerCase().includes(query) &&
                exts.some(ext => f.fileName.toLowerCase().endsWith(ext)));
        });
        const isQuestionnaireScreen = computed(() => selectedMove.value?.appScreen != null &&
            selectedMove.value.appScreen.includes('Questionnaires') &&
            !selectedMove.value.appScreen.includes('InBest'));
        function showToast(message) {
            successMessage.value = message;
            showSuccessToast.value = true;
        }
        function showError(message) {
            errorMessage.value = message;
            showErrorToast.value = true;
        }
        function loadMoves(autoSelect) {
            admin.getMoves((result) => {
                moves.value = Array.isArray(result) ? result : [];
                if (autoSelect && moves.value.length > 0) {
                    selectMove(moves.value[0]);
                }
            });
        }
        function getCriteria() {
            admin.getMoveCriteria((result) => {
                criteria.value = Array.isArray(result) ? result : [];
            });
        }
        function selectMove(p) {
            selectedMove.value = p;
            setActionType();
        }
        // The action type is implied by whichever action field is populated
        // (precedence matches the old admin: appScreen → cmsPage → websiteUrl)
        function setActionType() {
            actionType.value = null;
            const p = selectedMove.value;
            if (!p)
                return;
            if (p.appScreen != null && p.appScreen !== '')
                actionType.value = 'appScreen';
            if (p.cmsPage != null && p.cmsPage !== '')
                actionType.value = 'cmsPage';
            if (p.websiteUrl != null && p.websiteUrl !== '')
                actionType.value = 'websiteUrl';
            if (p.bakedAction != null && p.bakedAction !== '')
                actionType.value = 'bakedAction';
        }
        // Action types are mutually exclusive — picking one clears the others
        function updateMoveAction(at) {
            actionType.value = at;
            const p = selectedMove.value;
            if (at !== 'appScreen')
                p.appScreen = '';
            if (at !== 'cmsPage')
                p.cmsPage = '';
            if (at !== 'websiteUrl')
                p.websiteUrl = '';
            if (at !== 'bakedAction')
                p.bakedAction = '';
        }
        // appScreen format: appscreen/Questionnaires/{key}/{questionsPerPage}
        function onQuestionnaireKeyInput(e) {
            const key = e.target.value;
            const arr = selectedMove.value.appScreen.split('/');
            const qpp = arr[3] != null && arr[3] !== '' && arr[3] !== 'undefined' && key !== 'InBest' ? '/' + arr[3] : '';
            selectedMove.value.appScreen = 'appscreen/Questionnaires/' + key + qpp;
        }
        function onQuestionsPerPageInput(e) {
            const qpp = e.target.value;
            const arr = selectedMove.value.appScreen.split('/');
            selectedMove.value.appScreen = 'appscreen/Questionnaires/' + arr[2] + '/' + qpp;
        }
        function onShoutChange() {
            if (selectedMove.value.shout)
                selectedMove.value.isAlsoNotification = true;
        }
        function addAction() {
            selectedMove.value.actions.push({
                cta: '',
                appScreen: '',
                cmsPage: '',
                externalURL: ''
            });
        }
        function removeAction(action) {
            const i = selectedMove.value.actions.indexOf(action);
            selectedMove.value.actions.splice(i, 1);
        }
        function openImagePicker(field) {
            openPicker(field, 'image');
        }
        function openVideoPicker(field) {
            openPicker(field, 'video');
        }
        function openPicker(field, mode) {
            pickerField.value = field;
            pickerMode.value = mode;
            fileSearchQuery.value = '';
            showFilePicker.value = true;
            admin.getFiles((files) => {
                cdnFiles.value = files || [];
            });
        }
        function selectFile(file) {
            if (pickerField.value)
                selectedMove.value[pickerField.value] = file.uri;
            showFilePicker.value = false;
            pickerField.value = null;
        }
        function openCriteriaDrawer() {
            showCriteriaDrawer.value = true;
            if (criteria.value.length === 0)
                getCriteria();
        }
        function saveMove() {
            if (!selectedMove.value.id) {
                admin.createMove(selectedMove.value, (result) => {
                    selectedMove.value = result;
                    setActionType();
                    loadMoves(false);
                    showToast('Move created OK');
                }, (error) => {
                    showError(error);
                });
            }
            else {
                admin.updateMove(selectedMove.value.id, selectedMove.value, (result) => {
                    selectedMove.value = result;
                    setActionType();
                    loadMoves(false);
                    showToast('Move saved OK');
                }, (error) => {
                    showError(error);
                });
            }
        }
        function doDeleteMove() {
            showDeleteConfirm.value = false;
            admin.deleteMove(selectedMove.value.id, () => {
                selectedMove.value = null;
                loadMoves(true);
                showToast('Move deleted OK');
            }, (error) => {
                showError(error);
            });
        }
        function newMove() {
            selectedMove.value = {
                criteria: '',
                sticky: false,
                financialRank: 0,
                wellbeingRank: 0,
                validFrom: '2022-03-15',
                validTo: '2029-03-15',
                defaultDelayPeriodDays: 7,
                name: '',
                priority: moves.value.length + 1,
                oncePerSpendingCycle: false,
                title: '',
                tagLine: '',
                description: '',
                actionButtonText: '',
                backgroundImage: '',
                backgroundVideo: '',
                thumbnail: '',
                darkMode: false,
                websiteUrl: '',
                appScreen: '',
                cmsPage: '',
                actions: [],
                timeToComplete: 0,
                enabled: false,
                onSignup: false,
                isAlsoNotification: false,
                isOnlyNotification: false,
                shout: false,
                aiMove: false,
                bakedAction: ''
            };
            actionType.value = null;
        }
        function onLoad() {
            loadMoves(true);
            getCriteria();
        }
        onMounted(onLoad);
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[59] || (_cache[59] = _createElementVNode("div", { class: "list-header" }, [
                            _createElementVNode("h2", null, "Moves")
                        ], -1)),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("button", {
                                class: _normalizeClass(["action-btn", listFilter.value === 'all' ? 'primary' : 'secondary']),
                                onClick: _cache[0] || (_cache[0] = ($event) => (listFilter.value = 'all'))
                            }, "All", 2),
                            _createElementVNode("button", {
                                class: _normalizeClass(["action-btn", listFilter.value === 'cms' ? 'primary' : 'secondary']),
                                onClick: _cache[1] || (_cache[1] = ($event) => (listFilter.value = 'cms'))
                            }, "CMS", 2),
                            _createElementVNode("button", {
                                class: _normalizeClass(["action-btn", listFilter.value === 'screen' ? 'primary' : 'secondary']),
                                onClick: _cache[2] || (_cache[2] = ($event) => (listFilter.value = 'screen'))
                            }, "Screen", 2),
                            _createElementVNode("button", {
                                class: _normalizeClass(["action-btn", listFilter.value === 'website' ? 'primary' : 'secondary']),
                                onClick: _cache[3] || (_cache[3] = ($event) => (listFilter.value = 'website'))
                            }, "Website", 2)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((searchQuery).value = $event)),
                                type: "text",
                                placeholder: "Search Moves...",
                                class: "search-input"
                            }, null, 512), [
                                [_vModelText, searchQuery.value]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(filteredMoves.value.length) + " Moves", 1),
                        _createElementVNode("div", _hoisted_7, [
                            (filteredMoves.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMoves.value, (p) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: p.id,
                                            class: _normalizeClass(["move-item", { selected: selectedMove.value && selectedMove.value.id === p.id }]),
                                            onClick: ($event) => (selectMove(p))
                                        }, [
                                            _createElementVNode("div", _hoisted_10, _toDisplayString(p.aiMove ? 'AI: ' : '') + _toDisplayString(p.name), 1),
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["move-enabled", { on: p.enabled }])
                                                }, _toDisplayString(p.enabled ? 'On' : 'Off'), 3),
                                                _createElementVNode("span", _hoisted_12, "P" + _toDisplayString(p.priority), 1)
                                            ])
                                        ], 10, _hoisted_9));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_13, " No Moves found "))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("button", {
                                class: "action-btn secondary",
                                onClick: newMove
                            }, "New Move"),
                            (selectedMove.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("button", {
                                        class: "action-btn primary",
                                        onClick: saveMove
                                    }, _toDisplayString(selectedMove.value.id ? 'Save Changes' : 'Create Move'), 1),
                                    (selectedMove.value.id)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "action-btn danger",
                                            onClick: _cache[5] || (_cache[5] = ($event) => (showDeleteConfirm.value = true))
                                        }, "Delete"))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                        class: "action-btn secondary",
                                        onClick: onLoad
                                    }, "Reload")
                                ], 64))
                                : _createCommentVNode("", true)
                        ]),
                        (selectedMove.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, _toDisplayString(selectedMove.value.id || 'New Move'), 1),
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _cache[60] || (_cache[60] = _createElementVNode("label", null, "Name:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((selectedMove.value.name) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedMove.value.name]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                        _cache[61] || (_cache[61] = _createElementVNode("label", null, "Title:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((selectedMove.value.title) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedMove.value.title]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                    _createElementVNode("div", _hoisted_22, [
                                        _cache[62] || (_cache[62] = _createElementVNode("label", null, "Priority:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((selectedMove.value.priority) = $event)),
                                            type: "number",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedMove.value.priority]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_23, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((selectedMove.value.enabled) = $event)),
                                                type: "checkbox",
                                                class: "form-checkbox"
                                            }, null, 512), [
                                                [_vModelCheckbox, selectedMove.value.enabled]
                                            ]),
                                            _cache[63] || (_cache[63] = _createTextVNode(" Enabled"))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((selectedMove.value.sticky) = $event)),
                                                type: "checkbox",
                                                class: "form-checkbox"
                                            }, null, 512), [
                                                [_vModelCheckbox, selectedMove.value.sticky]
                                            ]),
                                            _cache[64] || (_cache[64] = _createTextVNode(" Sticky"))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((selectedMove.value.onSignup) = $event)),
                                                type: "checkbox",
                                                class: "form-checkbox"
                                            }, null, 512), [
                                                [_vModelCheckbox, selectedMove.value.onSignup]
                                            ]),
                                            _cache[65] || (_cache[65] = _createTextVNode(" Signup"))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((selectedMove.value.shout) = $event)),
                                                type: "checkbox",
                                                class: "form-checkbox",
                                                onChange: onShoutChange
                                            }, null, 544), [
                                                [_vModelCheckbox, selectedMove.value.shout]
                                            ]),
                                            _cache[66] || (_cache[66] = _createTextVNode(" Shout"))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((selectedMove.value.aiMove) = $event)),
                                                type: "checkbox",
                                                class: "form-checkbox"
                                            }, null, 512), [
                                                [_vModelCheckbox, selectedMove.value.aiMove]
                                            ]),
                                            _cache[67] || (_cache[67] = _createTextVNode(" AI"))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("div", { class: "label-with-button" }, [
                                        _cache[68] || (_cache[68] = _createElementVNode("label", null, "Criteria:", -1)),
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: openCriteriaDrawer
                                        }, "…")
                                    ]),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((selectedMove.value.criteria) = $event)),
                                        class: "form-textarea criteria-text",
                                        rows: "4"
                                    }, null, 512), [
                                        [_vModelText, selectedMove.value.criteria]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("div", _hoisted_30, [
                                        _cache[69] || (_cache[69] = _createElementVNode("label", null, "Tag Line:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((selectedMove.value.tagLine) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedMove.value.tagLine]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                        _cache[70] || (_cache[70] = _createElementVNode("label", null, "Feature tags (admin only):", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((selectedMove.value.featureTags) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedMove.value.featureTags]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                    _cache[71] || (_cache[71] = _createElementVNode("label", null, "Description:", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((selectedMove.value.description) = $event)),
                                        class: "form-textarea",
                                        rows: "3"
                                    }, null, 512), [
                                        [_vModelText, selectedMove.value.description]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, [
                                        _cache[72] || (_cache[72] = _createElementVNode("label", null, "Time to Complete (mins):", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((selectedMove.value.timeToComplete) = $event)),
                                            type: "number",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedMove.value.timeToComplete]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_35, [
                                        _cache[73] || (_cache[73] = _createElementVNode("label", null, "Delay after customer delay (days):", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((selectedMove.value.defaultDelayPeriodDays) = $event)),
                                            type: "number",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedMove.value.defaultDelayPeriodDays]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_36, [
                                        _cache[74] || (_cache[74] = _createElementVNode("label", null, "Delay after actioned (days):", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((selectedMove.value.delayAfterActionDays) = $event)),
                                            type: "number",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedMove.value.delayAfterActionDays]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("label", null, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((selectedMove.value.oncePerSpendingCycle) = $event)),
                                            type: "checkbox",
                                            class: "form-checkbox"
                                        }, null, 512), [
                                            [_vModelCheckbox, selectedMove.value.oncePerSpendingCycle]
                                        ]),
                                        _cache[75] || (_cache[75] = _createTextVNode(" Show only once per spending cycle"))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                    _cache[76] || (_cache[76] = _createElementVNode("label", null, "Action Button Text:", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((selectedMove.value.actionButtonText) = $event)),
                                        type: "text",
                                        class: "form-input"
                                    }, null, 512), [
                                        [_vModelText, selectedMove.value.actionButtonText]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_39, [
                                    _cache[77] || (_cache[77] = _createElementVNode("label", null, "Background Image:", -1)),
                                    _createElementVNode("div", _hoisted_40, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((selectedMove.value.backgroundImage) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedMove.value.backgroundImage]
                                        ]),
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: _cache[24] || (_cache[24] = ($event) => (openImagePicker('backgroundImage')))
                                        }, "Pick")
                                    ]),
                                    (selectedMove.value.backgroundImage)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: selectedMove.value.backgroundImage,
                                            class: "media-preview"
                                        }, null, 8, _hoisted_41))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_42, [
                                    _cache[78] || (_cache[78] = _createElementVNode("label", null, "Background Video:", -1)),
                                    _createElementVNode("div", _hoisted_43, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((selectedMove.value.backgroundVideo) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedMove.value.backgroundVideo]
                                        ]),
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: _cache[26] || (_cache[26] = ($event) => (openVideoPicker('backgroundVideo')))
                                        }, "Pick")
                                    ]),
                                    (selectedMove.value.backgroundVideo)
                                        ? (_openBlock(), _createElementBlock("video", {
                                            key: 0,
                                            src: selectedMove.value.backgroundVideo,
                                            class: "media-preview",
                                            controls: "",
                                            muted: "",
                                            preload: "metadata"
                                        }, null, 8, _hoisted_44))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_45, [
                                    _cache[79] || (_cache[79] = _createElementVNode("label", null, "Thumbnail:", -1)),
                                    _createElementVNode("div", _hoisted_46, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((selectedMove.value.thumbnail) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, selectedMove.value.thumbnail]
                                        ]),
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: _cache[28] || (_cache[28] = ($event) => (openImagePicker('thumbnail')))
                                        }, "Pick")
                                    ]),
                                    (selectedMove.value.thumbnail)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: selectedMove.value.thumbnail,
                                            class: "media-preview"
                                        }, null, 8, _hoisted_47))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_48, [
                                    _cache[93] || (_cache[93] = _createElementVNode("h4", null, "Move action", -1)),
                                    _createElementVNode("div", _hoisted_49, [
                                        _cache[80] || (_cache[80] = _createElementVNode("span", null, "1)", -1)),
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["action-btn", actionType.value === 'appScreen' ? 'primary' : 'secondary']),
                                            onClick: _cache[29] || (_cache[29] = ($event) => (updateMoveAction('appScreen')))
                                        }, "App Screen", 2),
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["action-btn", actionType.value === 'cmsPage' ? 'primary' : 'secondary']),
                                            onClick: _cache[30] || (_cache[30] = ($event) => (updateMoveAction('cmsPage')))
                                        }, "CMS Page", 2),
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["action-btn", actionType.value === 'websiteUrl' ? 'primary' : 'secondary']),
                                            onClick: _cache[31] || (_cache[31] = ($event) => (updateMoveAction('websiteUrl')))
                                        }, "Website URL", 2),
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["action-btn", actionType.value === 'bakedAction' ? 'primary' : 'secondary']),
                                            onClick: _cache[32] || (_cache[32] = ($event) => (updateMoveAction('bakedAction')))
                                        }, "Baked Action", 2)
                                    ]),
                                    (actionType.value === 'appScreen')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                            _cache[86] || (_cache[86] = _createElementVNode("p", { class: "step-hint" }, "2) Choose a well known app screen from the dropdown, or enter it manually in the text box.", -1)),
                                            _createElementVNode("div", _hoisted_51, [
                                                _createElementVNode("div", _hoisted_52, [
                                                    _cache[81] || (_cache[81] = _createElementVNode("label", null, "Select:", -1)),
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((selectedMove.value.appScreen) = $event)),
                                                        class: "form-input"
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(APP_SCREEN_OPTIONS), (opt) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                key: opt.value,
                                                                value: opt.value
                                                            }, _toDisplayString(opt.text), 9, _hoisted_53));
                                                        }), 128))
                                                    ], 512), [
                                                        [_vModelSelect, selectedMove.value.appScreen]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_54, [
                                                    _cache[82] || (_cache[82] = _createElementVNode("label", null, "Manual:", -1)),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => ((selectedMove.value.appScreen) = $event)),
                                                        type: "text",
                                                        class: "form-input"
                                                    }, null, 512), [
                                                        [_vModelText, selectedMove.value.appScreen]
                                                    ])
                                                ])
                                            ]),
                                            (isQuestionnaireScreen.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                    _createElementVNode("div", _hoisted_56, [
                                                        _cache[83] || (_cache[83] = _createElementVNode("label", null, "3) Questionnaire Key:", -1)),
                                                        _createElementVNode("input", {
                                                            type: "text",
                                                            class: "form-input",
                                                            onInput: onQuestionnaireKeyInput
                                                        }, null, 32)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_57, [
                                                        _cache[84] || (_cache[84] = _createElementVNode("label", null, "4) Number of questions per page:", -1)),
                                                        _createElementVNode("input", {
                                                            type: "text",
                                                            class: "form-input",
                                                            onInput: onQuestionsPerPageInput
                                                        }, null, 32)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_58, [
                                                _cache[85] || (_cache[85] = _createTextVNode("Final Move Action (admin): ")),
                                                _createElementVNode("p", null, _toDisplayString(selectedMove.value.appScreen), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (actionType.value === 'cmsPage')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                            _createElementVNode("div", _hoisted_60, [
                                                _cache[87] || (_cache[87] = _createElementVNode("label", null, "2) CMS Page Key:", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => ((selectedMove.value.cmsPage) = $event)),
                                                    type: "text",
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, selectedMove.value.cmsPage]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_61, [
                                                _cache[88] || (_cache[88] = _createTextVNode("Final Move Action (admin): ")),
                                                _createElementVNode("p", null, _toDisplayString(selectedMove.value.cmsPage), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (actionType.value === 'websiteUrl')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                            _createElementVNode("div", _hoisted_63, [
                                                _cache[89] || (_cache[89] = _createElementVNode("label", null, "2) Website URL:", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((selectedMove.value.websiteUrl) = $event)),
                                                    type: "text",
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, selectedMove.value.websiteUrl]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_64, [
                                                _cache[90] || (_cache[90] = _createTextVNode("Final Move Action (admin): ")),
                                                _createElementVNode("p", null, _toDisplayString(selectedMove.value.websiteUrl), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (actionType.value === 'bakedAction')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                            _createElementVNode("div", _hoisted_66, [
                                                _cache[91] || (_cache[91] = _createElementVNode("label", null, "2) Action:", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event) => ((selectedMove.value.bakedAction) = $event)),
                                                    type: "text",
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, selectedMove.value.bakedAction]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_67, [
                                                _cache[92] || (_cache[92] = _createTextVNode("Final Move Action (admin): ")),
                                                _createElementVNode("p", null, _toDisplayString(selectedMove.value.bakedAction), 1)
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                (actionType.value !== 'bakedAction')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedMove.value.actions, (action, index) => {
                                            return (_openBlock(), _createBlock(AppActionCard, {
                                                key: action.id || index,
                                                action: action,
                                                onDelete: ($event) => (removeAction(action))
                                            }, null, 8, ["action", "onDelete"]));
                                        }), 128)),
                                        _createElementVNode("div", { class: "form-group" }, [
                                            _createElementVNode("button", {
                                                class: "action-btn secondary",
                                                onClick: addAction
                                            }, "Add Action")
                                        ])
                                    ], 64))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_68, [
                                    _createElementVNode("label", null, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event) => ((selectedMove.value.darkMode) = $event)),
                                            type: "checkbox",
                                            class: "form-checkbox"
                                        }, null, 512), [
                                            [_vModelCheckbox, selectedMove.value.darkMode]
                                        ]),
                                        _cache[94] || (_cache[94] = _createTextVNode(" Dark Mode"))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_69, [
                                    _createElementVNode("label", null, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event) => ((selectedMove.value.isAlsoNotification) = $event)),
                                            type: "checkbox",
                                            class: "form-checkbox"
                                        }, null, 512), [
                                            [_vModelCheckbox, selectedMove.value.isAlsoNotification]
                                        ]),
                                        _cache[95] || (_cache[95] = _createTextVNode(" Sends push notification"))
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_70, [
                                    _createElementVNode("label", null, [
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => ((selectedMove.value.isOnlyNotification) = $event)),
                                            type: "checkbox",
                                            class: "form-checkbox"
                                        }, null, 512), [
                                            [_vModelCheckbox, selectedMove.value.isOnlyNotification]
                                        ]),
                                        _cache[96] || (_cache[96] = _createTextVNode(" Is ONLY notification (not in app moves)"))
                                    ])
                                ]),
                                (selectedMove.value.isAlsoNotification || selectedMove.value.isOnlyNotification)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("div", _hoisted_71, [
                                            _cache[97] || (_cache[97] = _createElementVNode("label", null, "Notification Title:", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => ((selectedMove.value.notificationTitle) = $event)),
                                                type: "text",
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, selectedMove.value.notificationTitle]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_72, [
                                            _cache[98] || (_cache[98] = _createElementVNode("label", null, "Notification Body:", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event) => ((selectedMove.value.notificationBody) = $event)),
                                                type: "text",
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, selectedMove.value.notificationBody]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_73, [
                                            _cache[99] || (_cache[99] = _createElementVNode("label", null, "Notification Image (optional):", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event) => ((selectedMove.value.notificationImageUrl) = $event)),
                                                type: "text",
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, selectedMove.value.notificationImageUrl]
                                            ])
                                        ])
                                    ], 64))
                                    : _createCommentVNode("", true)
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_74, " Select a Move to view details "))
                    ])
                ]),
                (showCriteriaDrawer.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "drawer-overlay",
                        onClick: _cache[46] || (_cache[46] = ($event) => (showCriteriaDrawer.value = false))
                    }, [
                        _createElementVNode("div", {
                            class: "drawer",
                            onClick: _cache[45] || (_cache[45] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_75, [
                                _cache[100] || (_cache[100] = _createElementVNode("h3", null, "Criteria Facts", -1)),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: _cache[44] || (_cache[44] = ($event) => (showCriteriaDrawer.value = false))
                                }, "✕")
                            ]),
                            _createElementVNode("div", _hoisted_76, [
                                (criteria.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(criteria.value, (c) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: c.id || c.fact,
                                                class: "action-btn secondary fact-btn",
                                                title: c.description,
                                                onClick: ($event) => (selectedMove.value.criteria += c.fact)
                                            }, _toDisplayString(c.fact), 9, _hoisted_78));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_79, "No criteria facts available"))
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (showFilePicker.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "modal-overlay",
                        onClick: _cache[50] || (_cache[50] = ($event) => (showFilePicker.value = false))
                    }, [
                        _createElementVNode("div", {
                            class: "modal-dialog modal-large",
                            onClick: _cache[49] || (_cache[49] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("h3", null, _toDisplayString(pickerMode.value === 'video' ? 'Select a Video' : 'Select an Image'), 1),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: _cache[47] || (_cache[47] = ($event) => (showFilePicker.value = false))
                                }, "✕")
                            ]),
                            _createElementVNode("div", _hoisted_81, [
                                _createElementVNode("div", _hoisted_82, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event) => ((fileSearchQuery).value = $event)),
                                        type: "text",
                                        placeholder: pickerMode.value === 'video' ? 'Search videos...' : 'Search images...',
                                        class: "search-input"
                                    }, null, 8, _hoisted_83), [
                                        [_vModelText, fileSearchQuery.value]
                                    ])
                                ]),
                                (filteredCdnFiles.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCdnFiles.value, (file) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: file.fileName,
                                                class: "file-card",
                                                onClick: ($event) => (selectFile(file))
                                            }, [
                                                _createElementVNode("div", _hoisted_86, [
                                                    (pickerMode.value === 'video')
                                                        ? (_openBlock(), _createElementBlock("video", {
                                                            key: 0,
                                                            src: file.uri,
                                                            muted: "",
                                                            preload: "metadata"
                                                        }, null, 8, _hoisted_87))
                                                        : (_openBlock(), _createElementBlock("img", {
                                                            key: 1,
                                                            src: file.uri,
                                                            alt: file.fileName
                                                        }, null, 8, _hoisted_88))
                                                ]),
                                                _createElementVNode("div", _hoisted_89, [
                                                    _createElementVNode("div", {
                                                        class: "file-card-name",
                                                        title: file.fileName
                                                    }, _toDisplayString(file.fileName), 9, _hoisted_90)
                                                ])
                                            ], 8, _hoisted_85));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_91, "No " + _toDisplayString(pickerMode.value === 'video' ? 'videos' : 'images') + " found in CDN.", 1))
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (showDeleteConfirm.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "modal-overlay",
                        onClick: _cache[54] || (_cache[54] = ($event) => (showDeleteConfirm.value = false))
                    }, [
                        _createElementVNode("div", {
                            class: "modal-dialog",
                            onClick: _cache[53] || (_cache[53] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_92, [
                                _cache[101] || (_cache[101] = _createElementVNode("h3", null, "Delete Move", -1)),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: _cache[51] || (_cache[51] = ($event) => (showDeleteConfirm.value = false))
                                }, "✕")
                            ]),
                            _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("p", null, [
                                    _cache[102] || (_cache[102] = _createTextVNode("Are you sure you want to delete ")),
                                    _createElementVNode("strong", null, _toDisplayString(selectedMove.value?.name), 1),
                                    _cache[103] || (_cache[103] = _createTextVNode("? This action cannot be undone."))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_94, [
                                _createElementVNode("button", {
                                    class: "action-btn danger",
                                    onClick: doDeleteMove
                                }, "Yes, Delete"),
                                _createElementVNode("button", {
                                    class: "action-btn secondary",
                                    onClick: _cache[52] || (_cache[52] = ($event) => (showDeleteConfirm.value = false))
                                }, "Cancel")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_v_snackbar, {
                    modelValue: showSuccessToast.value,
                    "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event) => ((showSuccessToast).value = $event)),
                    timeout: 3000,
                    location: "bottom",
                    color: "success"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[55] || (_cache[55] = ($event) => (showSuccessToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(successMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_snackbar, {
                    modelValue: showErrorToast.value,
                    "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event) => ((showErrorToast).value = $event)),
                    timeout: 4000,
                    location: "bottom",
                    color: "error"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[57] || (_cache[57] = ($event) => (showErrorToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(errorMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
